import { CardPaymentMethod, SepaPaymentMethod } from '@mews-commander/data-access';

export type PaymentMethodCommonValues = Pick<
    CardPaymentMethod | SepaPaymentMethod,
    | 'id'
    | 'creatorProfileName'
    | 'createdUtc'
    | 'lastDigits'
    | 'state'
    | 'paymentMethodActions'
    | 'paymentMethod'
    | 'source'
    | 'paymentPlanId'
>;
type CardPaymentMethodValues = Pick<
    CardPaymentMethod,
    | 'accountId'
    | 'type'
    | 'holderName'
    | 'expiration'
    | 'format'
    | 'isGatewayProvider'
    | 'creatorProfileName'
    | 'wallet'
    | 'storageId'
>;
type SepaPaymentMethodValues = Pick<SepaPaymentMethod, 'payerName'>;

interface MappedPaymentMethodValues {
    title: string;
}

export type PaymentMethodRecord = PaymentMethodCommonValues &
    CardPaymentMethodValues &
    SepaPaymentMethodValues &
    MappedPaymentMethodValues;

export enum EmptyPaymentMethodStatus {
    Missing = 'Missing',
    Pending = 'Pending',
}
